
const languages = [
  { label: "English (US)", code: "en-US", i18nValue: "en", flagcode: "gb" },
  { label: "English", code: "en-GB", i18nValue: "en", flagcode: "gb" },
  { label: "Norsk", code: "nb-NO", i18nValue: "no", flagcode: "no" },
  { label: "Svensk", code: "sv-SE", i18nValue: "sv", flagcode: "se" },
  { label: "中国人", code: "zh-CN", i18nValue: "zh-CN", flagcode: "cn" },
  { label: "廣東話", code: "zh-HK", i18nValue: "zh-HK", flagcode: "hk" },
];

export default languages;